import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  onShowPopUp?: () => void
}

export const MplusNotAllowCard: FC<Props> = ({ onShowPopUp }) => {
  const { t } = useTranslation()
  return (
    <div className={s.container}>
      <div className={s.header}>
        <span className={clsx(s.text, 'semi-bold-13')}>
          {t('mplus.connect_mplus')}
        </span>

        <AppIcon
          className={s.icon}
          id={AllIcons.INFO}
          onClick={onShowPopUp}
        />
      </div>

      <div className={clsx(s.footer, 'regular-10')}>
        {t('mplus.mplus_connect')}
      </div>
    </div>
  )
}
